import styles from "../Editor.module.scss";

const ListBlock = ({items = []}) => {
    if (!items.length) return null;

    return (
        <ul className={styles.reList}>
            {items.map((item, index) => (
                <li key={index} className={styles.reListItem} dangerouslySetInnerHTML={{__html: item}}></li>
            ))}
        </ul>
    );
};

export default ListBlock;
